import Vue from 'vue';
import App from '@/App.vue';
import Notifications from 'vue-notification';
import NotifyPlugin from './plugins/NotifyPlugin';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import ToggleSwitchControl from './components/ToggleSwitchControl.vue';
import Spinner from '@/components/Spinner.vue';
import CheckboxControl from './components/CheckboxControl.vue';
import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader, BallClipRotateLoader } from 'vue-loaders';
import TimePickerControl from "@/components/TimePickerControl.vue";
import Fragment from 'vue-fragment';
import {installFilters} from '@/plugins/BekFilters';
Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(NotifyPlugin);
// Plugin to hack around Vue's limitation that each component must have a single root element.
// Sometimes we want a component to contain multiple elements that should all pretend to be "root" elements
// so they can play nice with their grandparent's (the component's parent) styling (e.g. in CSS Gridbox)
Vue.use(Fragment.Plugin);

installFilters();

Vue.component(flatPickr.name, flatPickr);
Vue.component(TimePickerControl.name, TimePickerControl);
Vue.component('switch-control', ToggleSwitchControl);
Vue.component('checkbox-control', CheckboxControl);
Vue.component('vue-simple-spinner', Spinner);
Vue.component(BallPulseLoader.name, BallPulseLoader);
Vue.component(BallClipRotateLoader.name, BallClipRotateLoader);

// Global mixins aren't ideal but in this case it will do the job nicely
Vue.mixin({
    data() {
        return {
            globalFlatpickrConfig: {
                allowInput: true,
                altInput: true,
                altFormat: 'm/d/Y',
                locale: {
                    'firstDayOfWeek': 0 // start week on Sunday
                },
                dateFormat: 'Z',
                onClose: function (selectedDates:any, dateStr:any, instance:any) {
                    // This sets the date to what is in the input box when tabbing off of the date.
                    instance.setDate(instance._input.value, true, instance.config.altFormat);
                },
            }
        };
    }
});

new Vue({
    el: '#app',
    render: (h) => h(App),
}).$mount('#app');
